module.exports = __webpack_public_path__ + "static/media/starts_with_s.bfa59d5d.mp3";